import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  RESTAURANT_CHEF_CREATE,
  RESTAURANT_CHEF_EDIT,
  RESTAURANT_CHEF_VIEW,
  RESTAURANT_CREATE,
  RESTAURANT_EDIT,
  RESTAURANT_TYPE_CHEF,
  RESTAURANT_TYPE_INFO,
  RESTAURANT_VIEW,
} from '../../../constants/restaurantConst';
import { useSelector } from 'react-redux';
import { allRestaurantLoaderSelector, selectedHotelSelector } from '../../property/propertySlice';
import { useHistory, useLocation } from 'react-router-dom';
import { Drawer, Button } from '@material-ui/core';
import InfoList from './info/info-list/Info-List';
import InfoCreate from './info/info-create/Info-create';
import InfoView from './info/info-view/Info-View';
import ChefList from './chef/chef-list/Chef-List';
import ChefCreate from './chef/chef-create/Chef-Create';
import ChefView from './chef/chef-view/Chef-View';
import { validateUserSession } from '../../../utils/authUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Restaurant = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const allRestaurantLoader = useSelector(allRestaurantLoaderSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const history = useHistory();
  const search = useLocation().search;

  const tabToOpen = new URLSearchParams(search).get('tab');
  const [activeTab, setActiveTab] = useState(tabToOpen || RESTAURANT_TYPE_INFO);
  const [state, setState] = useState({
    type: RESTAURANT_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: RESTAURANT_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();

  useEffect(() => {
    if (activeTab === RESTAURANT_TYPE_CHEF || activeTab === RESTAURANT_TYPE_INFO) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(RESTAURANT_TYPE_INFO);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case RESTAURANT_CREATE:
        return (
          <InfoCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case RESTAURANT_EDIT:
        return (
          <InfoCreate
            toggleDrawer={onDrawerToggle}
            restaurant={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case RESTAURANT_CHEF_CREATE:
        return (
          <ChefCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case RESTAURANT_CHEF_EDIT:
        return (
          <ChefCreate
            toggleDrawer={onDrawerToggle}
            chef={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case RESTAURANT_VIEW:
        return (
          <InfoView
            restaurantObj={inpState.obj}
            permissions={permissions}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case RESTAURANT_CHEF_VIEW:
        return (
          <ChefView
            chefObj={inpState.obj}
            permissions={permissions}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(true)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <div className='container mt-3'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Restaurants</span>
            </div>
          </div>
          <div className='row d-flex mt-3 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === RESTAURANT_TYPE_INFO ? 'outlined' : 'text'}
                className={
                  activeTab === RESTAURANT_TYPE_INFO
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(RESTAURANT_TYPE_INFO)}
              >
                Info
              </Button>

              <Button
                size='large'
                variant={activeTab === RESTAURANT_TYPE_CHEF ? 'outlined' : 'text'}
                className={
                  activeTab === RESTAURANT_TYPE_CHEF
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={(e) => setActiveTab(RESTAURANT_TYPE_CHEF)}
              >
                Chef
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === RESTAURANT_TYPE_INFO && (
                <InfoList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  allRestaurantLoader={allRestaurantLoader}
                  hotelId={selectedHotel}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === RESTAURANT_TYPE_CHEF && (
                <ChefList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  permissions={permissions}
                  allRestaurantLoader={allRestaurantLoader}
                  hotelId={selectedHotel}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Restaurant;
